import { CONSTS } from 'config/objectConst'

export const getActions = (): Action[] => [
	{
		arrow: true,
		available: CONSTS.AVAILABLE_ACTIONS.Connect.Visible,
		localeAvailable: true,
		name: CONSTS.AVAILABLE_ACTIONS.Connect.Title,
		open: true,
		params: {
			launchActionIn: false,
			mainCustomFields: CONSTS.MAIN_CUSTOM_FIELDS,
			overflowCustomFields: CONSTS.OVERFLOW_CUSTOM_FIELDS,
			period: Number,
			sendMessageTo: false,
			textarea: String
		},
		status: false,
		type: CONSTS.AVAILABLE_ACTIONS.Connect.Type,
		validation: {
			actionName: true
		},
		values: {
			delay: CONSTS.DEFAULT_DATE_ACTIONS_VALUE.CONNECT.DELAY.DEFAULT,
			launchActionIn: 0,
			mainCustomFields: CONSTS.MAIN_CUSTOM_FIELDS,
			overflowCustomFields: CONSTS.OVERFLOW_CUSTOM_FIELDS,
			period: CONSTS.DEFAULT_DATE_ACTIONS_VALUE.CONNECT.WITHDRAW.DEFAULT * 1440,
			sendMessageTo: 'Contacts, who never replied',
			textarea: ''
		}
	},
	{
		arrow: true,
		available: CONSTS.AVAILABLE_ACTIONS.Message.Visible,
		localeAvailable: true,
		name: CONSTS.AVAILABLE_ACTIONS.Message.Title,
		open: true,
		params: {
			launchActionIn: false,
			mainCustomFields: CONSTS.MAIN_CUSTOM_FIELDS,
			overflowCustomFields: CONSTS.OVERFLOW_CUSTOM_FIELDS,
			period: false,
			sendMessageTo: false,
			textarea: String
		},
		status: false,
		type: CONSTS.AVAILABLE_ACTIONS.Message.Type
	},
	{
		arrow: false,
		available: CONSTS.AVAILABLE_ACTIONS.VisitProfile.Visible,
		localeAvailable: true,
		name: CONSTS.AVAILABLE_ACTIONS.VisitProfile.Title,
		open: false,
		params: {
			launchActionIn: false,
			period: false,
			sendMessageTo: false
		},
		status: false,
		type: CONSTS.AVAILABLE_ACTIONS.VisitProfile.Type
	},
	{
		arrow: false,
		available: CONSTS.AVAILABLE_ACTIONS.Follow.Visible,
		localeAvailable: true,
		name: CONSTS.AVAILABLE_ACTIONS.Follow.Title,
		open: false,
		params: {
			launchActionIn: false,
			period: false,
			sendMessageTo: false
		},
		status: false,
		type: CONSTS.AVAILABLE_ACTIONS.Follow.Type
	},
	{
		arrow: true,
		available: CONSTS.AVAILABLE_ACTIONS.ReactOnPost.Visible,
		localeAvailable: true,
		// ? I guess it's error, should be in params
		mainCustomFields: CONSTS.MAIN_CUSTOM_FIELDS,
		name: CONSTS.AVAILABLE_ACTIONS.ReactOnPost.Title,
		open: true,
		params: {
			currentEmotion: 'Like',
			emotion: CONSTS.EMOTION,
			launchActionIn: false,
			period: false,
			sendMessageTo: false
		},
		status: false,
		type: CONSTS.AVAILABLE_ACTIONS.ReactOnPost.Type
	},
	{
		arrow: false,
		available: CONSTS.AVAILABLE_ACTIONS.EndorseSkill.Visible,
		localeAvailable: true,
		name: CONSTS.AVAILABLE_ACTIONS.EndorseSkill.Title,
		open: false,
		params: {
			launchActionIn: false,
			period: false,
			sendMessageTo: false
		},
		status: false,
		type: CONSTS.AVAILABLE_ACTIONS.EndorseSkill.Type
	},
	{
		arrow: false,
		available: CONSTS.AVAILABLE_ACTIONS.ScrapeProfile.Visible,
		localeAvailable: true,
		name: CONSTS.AVAILABLE_ACTIONS.ScrapeProfile.Title,
		open: false,
		params: {
			launchActionIn: false,
			period: false,
			sendMessageTo: false
		},
		status: false,
		type: CONSTS.AVAILABLE_ACTIONS.ScrapeProfile.Type
	}
]

export type Action = {
	arrow: boolean
	available: boolean
	localeAvailable: boolean
	mainCustomFields?: string[]
	name: string
	open: boolean
	params: {
		currentEmotion?: string
		emotion?: string[]
		launchActionIn: boolean
		mainCustomFields?: string[]
		overflowCustomFields?: string[]
		period: false | NumberConstructor
		sendMessageTo: boolean
		textarea?: StringConstructor
	}
	status: boolean
	type: string

	validation?: {
		actionName: boolean
	}

	values?: {
		delay: number
		launchActionIn: number
		mainCustomFields: string[]
		overflowCustomFields: string[]
		period: number
		sendMessageTo: string
		textarea: string
	}
}
